function isInSchedule(startAux, endAux, appealDate) {
	const start = new Date(startAux);
	const end = new Date(endAux);
	const today = new Date(appealDate);
	if (today >= start && today <= end) {
		return true;
	}
	return false;
}

export default function returnAppealType(ps, appeal) {
	if (ps && ps.schedule) {
		const appealsSchedule = ps.schedule.filter((e) => e.type === 'RECURSO');
		if (appealsSchedule.length > 0) {
			for (let index = 0; index < appealsSchedule.length; index++) {
				const element = appealsSchedule[index];
				if (isInSchedule(element.start, element.end, appeal.createdAt)) {
					return element.title;
				}
			}
		}
		return '';
	}
}
